module.exports = __webpack_public_path__ + "img/image 61@2x (1).27dc4534.png";